import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import ComplianceFitFinder from './ComplianceFitFinder';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ComplianceFitFinder />
  </React.StrictMode>
); 